import { render, staticRenderFns } from "./returnOrder.vue?vue&type=template&id=37720dd9&"
import script from "./returnOrder.vue?vue&type=script&lang=js&"
export * from "./returnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports